module.exports = "/_next/static/images/caf0a82c28ec1bfbb02b2fdbe0a53ad6-careers@1x.jpg.webp";